import { useQuery } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export type SubscriptionDetailsResponse = {
  subscriptionId: string;
  subscriptionState: 'ACTIVE' | 'PAUSED' | 'CANCELLED' | 'COMPLETED';
  subscriptionFrequency: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  amount: number;
  startDate: string;
  endDate: string | null;
  pausedOn: string | null;
  pausedTill: string | null;
  [key: string]: any;
};

export function getSubscriptionDetails(subscriptionId: string) {
  const path = NetworkManager.PATH.getUserSubscriptionDetails.replace('{{subscriptionId}}', subscriptionId);
  
  return NetworkManager.Call({
    method: 'get',
    path: path,
  });
}

export default function useSubscriptionDetails(subscriptionId?: string) {
  const { data, isLoading, isError, error, refetch } = useQuery(
    ['getSubscriptionDetails', subscriptionId],
    () => {
      if (!subscriptionId) {
        return Promise.resolve(null);
      }
      return getSubscriptionDetails(subscriptionId);
    },
    {
      enabled: !!subscriptionId,
    }
  );

  return {
    data: (data?.data || data) as SubscriptionDetailsResponse | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
}
